import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { getPartner } from '../../../core/partners/partner-registry';

export type PartnerLogoVariant = 'icon' | 'logo';

@Component({
  selector: 'app-partner-logo',
  templateUrl: './partner-logo.component.html',
  styleUrls: ['./partner-logo.component.scss'],
  imports: [CommonModule],
})
export class PartnerLogoComponent {
  @Input() partnerId?: number | null;
  @Input() variant: PartnerLogoVariant = 'logo';

  get src(): string | undefined {
    const partner = getPartner(this.partnerId);
    if (!partner) {
      return undefined;
    }
    return this.variant === 'icon' ? partner.icon : partner.logo;
  }

  get alt(): string {
    return getPartner(this.partnerId)?.displayName ?? '';
  }
}
